import React from 'react';
import { Checkbox as BootstrapCheckbox, FormControl } from 'react-bootstrap';

type CheckboxProps = {
  id: string;
  name: string;
  isChecked?: boolean;
  onChange: (params: { name: string; isChecked: boolean }) => void;
  label?: string;
  hasError?: boolean;
  readOnly?: boolean;
  inline?: boolean;
};

const Checkbox = ({
  id,
  name,
  isChecked = false,
  onChange,
  label,
  hasError = false,
  readOnly = false,
  inline = false,
}: CheckboxProps) => (
  <BootstrapCheckbox
    id={id}
    validationState={hasError ? 'error' : undefined}
    disabled={readOnly}
    inline={inline}
    onChange={({ currentTarget: { checked } }: React.FormEvent<FormControl & HTMLInputElement>) =>
      onChange({ name, isChecked: checked })
    }
    checked={isChecked}
  >
    {label}
  </BootstrapCheckbox>
);

export default Checkbox;
